/**
 * Offset Britain - Geo-Detection for Dynamic Content
 * Detects visitor country and updates page content accordingly
 */

(function() {
  'use strict';
  
  // Country configurations
  const countryConfig = {
    'US': {
      demonym: 'American',
      businessText: 'US businesses',
      individualsText: 'Americans',
      localText: 'across America',
      trustText: 'Trusted by US companies'
    },
    'CA': {
      demonym: 'Canadian',
      businessText: 'Canadian businesses',
      individualsText: 'Canadians',
      localText: 'across Canada',
      trustText: 'Trusted by Canadian companies'
    },
    'AU': {
      demonym: 'Australian',
      businessText: 'Australian businesses',
      individualsText: 'Australians',
      localText: 'across Australia',
      trustText: 'Trusted by Australian companies'
    },
    'DE': {
      demonym: 'German',
      businessText: 'German businesses',
      individualsText: 'Germans',
      localText: 'across Germany',
      trustText: 'Trusted by German companies'
    },
    'FR': {
      demonym: 'French',
      businessText: 'French businesses',
      individualsText: 'French citizens',
      localText: 'across France',
      trustText: 'Trusted by French companies'
    },
    'IE': {
      demonym: 'Irish',
      businessText: 'Irish businesses',
      individualsText: 'Irish citizens',
      localText: 'across Ireland',
      trustText: 'Trusted by Irish companies'
    },
    'GB': {
      demonym: 'British',
      businessText: 'UK businesses',
      individualsText: 'Britons',
      localText: 'across Britain',
      trustText: 'Trusted by UK companies'
    }
  };
  
  // Default to UK
  const defaultCountry = 'GB';
  
  // Check for cached country
  function getCachedCountry() {
    try {
      const cached = localStorage.getItem('ob_visitor_country');
      if (cached) {
        const data = JSON.parse(cached);
        // Cache for 24 hours
        if (Date.now() - data.timestamp < 86400000) {
          return data.country;
        }
      }
    } catch (e) {}
    return null;
  }
  
  // Cache country
  function cacheCountry(country) {
    try {
      localStorage.setItem('ob_visitor_country', JSON.stringify({
        country: country,
        timestamp: Date.now()
      }));
    } catch (e) {}
  }
  
  // Update page content based on country
  function updateContent(country) {
    const config = countryConfig[country] || countryConfig[defaultCountry];
    
    // Update elements with data-geo attributes
    document.querySelectorAll('[data-geo-business]').forEach(el => {
      el.textContent = el.textContent.replace(/UK businesses|US businesses|Canadian businesses|Australian businesses|German businesses|French businesses|Irish businesses/gi, config.businessText);
    });
    
    document.querySelectorAll('[data-geo-individuals]').forEach(el => {
      el.textContent = el.textContent.replace(/Britons|Americans|Canadians|Australians|Germans|French citizens|Irish citizens/gi, config.individualsText);
    });
    
    document.querySelectorAll('[data-geo-local]').forEach(el => {
      el.textContent = el.textContent.replace(/across Britain|across America|across Canada|across Australia|across Germany|across France|across Ireland/gi, config.localText);
    });
    
    // More flexible replacement for hero text
    document.querySelectorAll('[data-geo-text]').forEach(el => {
      let text = el.textContent;
      // Replace "UK" with country-specific version in common phrases
      if (country !== 'GB') {
        text = text.replace(/\bUK\b(?!\s+Company)/g, country);
        text = text.replace(/\bBritish\b/g, config.demonym);
        el.textContent = text;
      }
    });
    
    // Add class to body for CSS-based customization
    document.body.classList.add('geo-' + country.toLowerCase());
    document.body.setAttribute('data-visitor-country', country);
  }
  
  // Detect country using free IP API
  function detectCountry() {
    // Check cache first
    const cached = getCachedCountry();
    if (cached) {
      updateContent(cached);
      return;
    }
    
    // Use ipapi.co (free, no API key needed, 1000 requests/day)
    fetch('https://ipapi.co/country/', { 
      method: 'GET',
      cache: 'no-cache'
    })
    .then(response => {
      if (!response.ok) throw new Error('API error');
      return response.text();
    })
    .then(country => {
      country = country.trim().toUpperCase();
      if (country && country.length === 2) {
        cacheCountry(country);
        updateContent(country);
      } else {
        updateContent(defaultCountry);
      }
    })
    .catch(() => {
      // Fallback to UK on error
      updateContent(defaultCountry);
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectCountry);
  } else {
    detectCountry();
  }
  
  // Expose for manual override (useful for testing)
  window.OffsetBritainGeo = {
    setCountry: function(country) {
      cacheCountry(country);
      updateContent(country);
    },
    getCountry: getCachedCountry,
    clearCache: function() {
      localStorage.removeItem('ob_visitor_country');
    }
  };
  
})();
